export default __webpack_public_path__ + "static/media/480_business01-es-mobile.d12b0c42.png";